import { APIClient } from 'infra/APIClient'
import { APIConfig } from 'types/definitions'
import {
  CallCenterContactsQuery,
  CallCenterContactsResponseDTO,
} from 'call-center/dtos/call-center'
import { CancellationToken } from 'infra/cancellation'

export interface FreshbooksAPI {
  freshbooksHubspot: FreshbooksHubspotAPI
  callCenter: FreshbooksCallCenterAPI
}

export function createFreshbooksAPI(opts: APIConfig): FreshbooksAPI {
  return {
    freshbooksHubspot: new FreshbooksHubspotAPI(opts),
    callCenter: new FreshbooksCallCenterAPI(opts),
  }
}

export class FreshbooksHubspotAPI extends APIClient {
  getToken(): Promise<string> {
    return this.client.get('/hubspot-tracking').then((res) => res.data.token)
  }
}

export class FreshbooksCallCenterAPI extends APIClient {
  searchContacts(
    query: CallCenterContactsQuery,
    cancellationToken = CancellationToken.default,
  ): Promise<CallCenterContactsResponseDTO> {
    return this.client
      .get('/v1/call-center/contacts/search', {
        params: query,
        signal: cancellationToken.asAbortSignal(),
      })
      .then(this._data)
  }
}
